/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { of as observableOf, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Project, ProjectData, Models, Options, Layers } from '../../interfaces/common/project';

@Injectable()
export class ProjectsServiceMock extends ProjectData {
    basePath: string = './assets/images/projects/';

    /** Empty Structures: Layer > Option > Model */
    layerEmpty: Layers = {
        level: 1,
        itemActive: 0,
        itemDefaultName: '',
        itemDefaultCost: 0,
        itemDefaultThumbnail: '',
        items: [
            {
                name: '',
                cost: 0,
                thumbnail: '',
                pathLayerPicture: '',
            },
        ],
    };
    optionEmpty: Options = {
        id: '',
        name: '',
        description: '',
        pathBasePicture: '',
        subOptions: [
            {
                id: '',
                name: '',
                layers: [
                    this.layerEmpty,
                ],
            },
        ],
    };
    modelEmpty: Models = {
        id: '',
        name: '',
        description: '',
        coverPicture: '',
        modelPrice: '',
        views: [
            {
                id: '',
                name: '',
                subView: [
                    {
                        id: '',
                        name: '',
                        options: [
                            this.optionEmpty,
                        ],
                    },
                ],
            },
        ],
    };
    getAll(){
        return null;
    }
    getCurrentProject(){
        return null;
    }
    get(id: number){
        return null;
    }
    update(project: Project){
        return null;
    }
    updateCurrent(project: Project){
        return null;
    }
    /** Data: Exterior View - Front (Option 1): Short Porch */
/*    layerExtFrt1Brick: Layers = {
        level: 1,
        itemActive: 2,
        items: [
            {
                name: 'Farmington',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Brick/Layers/L1' + '/Farmington.png',
            },
            {
                name: 'Millbrook',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Brick/Layers/L1' + '/Millbrook.png',
            },
            {
                name: 'St Louis',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Brick/Layers/L1' + '/St Louis.png',
            }
        ]
    };
    layerExtFrt1Roof: Layers = {
        level: 1,
        itemActive: 1,
        items: [
            {
                name: 'Charcoal',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Roof/Layers/L1' + '/Charcoal.png',
            },
            {
                name: 'Driftwood',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Roof/Layers/L1' + '/Driftwood.png',
            },
            {
                name: 'Weatherwood',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Roof/Layers/L1' + '/Weatherwood.png',
            }
        ]
    };
    layerExtFrt1Shutters: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Gray',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Shutters/Layers/L1' + '/Gray.png',
            },
            {
                name: 'Green',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Shutters/Layers/L1' + '/Green.png',
            },
            {
                name: 'Red',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Shutters/Layers/L1' + '/Red.png',
            }
        ]
    };
    layerExtFrt1Siding: Layers = {
        level: 1,
        itemActive: -1,
        items: [
            {
                name: 'Cream',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Siding/Layers/L1' + '/Cream.png',
            },
            {
                name: 'Green',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Siding/Layers/L1' + '/Green.png',
            },
            {
                name: 'Tan',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Siding/Layers/L1' + '/Tan.png',
            }
        ]
    };
    layerExtFrt1Stone: Layers = {
        level: 1,
        itemActive: 1,
        items: [
            {
                name: 'Gray',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Stone/Layers/L1' + '/Gray.png',
            },
            {
                name: 'Natural',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Stone/Layers/L1' + '/Natural.png',
            },
            {
                name: 'Tan',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Stone/Layers/L1' + '/Tan.png',
            }
        ]
    };
    layerExtFrt1Trim: Layers = {
        level: 1,
        itemActive: 2,
        items: [
            {
                name: 'Blue',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Trim/Layers/L1' + '/Blue.png',
            },
            {
                name: 'Tan',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Trim/Layers/L1' + '/Tan.png',
            },
            {
                name: 'White',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/SubO_Trim/Layers/L1' + '/White.png',
            }
        ]
    };
    optionExteriorFront1: Options = {
        id: '1',
        name: 'Short Porch',
        description: 'Short porch with garage in front',
        pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Short Porch/Base/' + 'Short Porch.jpg',
        subOptions: [
            {
                id: '1',
                name: 'Brick',
                layers: [
                    this.layerExtFrt1Brick,
                ],
            },
            {
                id: '2',
                name: 'Roof',
                layers: [
                    this.layerExtFrt1Roof,
                ],
            },
            {
                id: '3',
                name: 'Shutters',
                layers: [
                    this.layerExtFrt1Shutters,
                ],
            },
            {
                id: '4',
                name: 'Siding',
                layers: [
                    this.layerExtFrt1Siding,
                ],
            },
            {
                id: '5',
                name: 'Stone',
                layers: [
                    this.layerExtFrt1Stone,
                ],
            },
            {
                id: '6',
                name: 'Trim',
                layers: [
                    this.layerExtFrt1Trim,
                ],
            }
        ]
    };
*/
    /** Data: Exterior View - Front (Option 2): Large Porch */
/*
    layerExtFrt2Brick: Layers = {
        level: 1,
        itemActive: -1,
        items: [
            {
                name: 'Farmington',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Brick/Layers/L1' + '/Farmington.png',
            },
            {
                name: 'Millbrook',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Brick/Layers/L1' + '/Millbrook.png',
            },
            {
                name: 'St Louis',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Brick/Layers/L1' + '/St Louis.png',
            }
        ]
    };
    layerExtFrt2Roof: Layers = {
        level: 1,
        itemActive: -1,
        items: [
            {
                name: 'Charcoal',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Roof/Layers/L1' + '/Charcoal.png',
            },
            {
                name: 'Driftwood',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Roof/Layers/L1' + '/Driftwood.png',
            },
            {
                name: 'Weatherwood',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Roof/Layers/L1' + '/Weatherwood.png',
            }
        ]
    };
    layerExtFrt2Shutters: Layers = {
        level: 1,
        itemActive: -1,
        items: [
            {
                name: 'Gray',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Shutters/Layers/L1' + '/Gray.png',
            },
            {
                name: 'Green',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Shutters/Layers/L1' + '/Green.png',
            },
            {
                name: 'Red',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Shutters/Layers/L1' + '/Red.png',
            }
        ]
    };
    layerExtFrt2Siding: Layers = {
        level: 1,
        itemActive: -1,
        items: [
            {
                name: 'Cream',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Siding/Layers/L1' + '/Cream.png',
            },
            {
                name: 'Green',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Siding/Layers/L1' + '/Green.png',
            },
            {
                name: 'Tan',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Siding/Layers/L1' + '/Tan.png',
            }
        ]
    };
    layerExtFrt2Stone: Layers = {
        level: 1,
        itemActive: -1,
        items: [
            {
                name: 'Gray',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Stone/Layers/L1' + '/Gray.png',
            },
            {
                name: 'Natural',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Stone/Layers/L1' + '/Natural.png',
            },
            {
                name: 'Tan',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/SubO_Stone/Layers/L1' + '/Tan.png',
            }
        ]
    };
    optionExteriorFront2: Options = {
        id: '2',
        name: 'Large Porch',
        description: 'Large porch with garage in front',
        pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Large Porch/Base/' + 'Large Porch.jpg',
        subOptions: [
            {
                id: '1',
                name: 'Brick',
                layers: [
                    this.layerExtFrt2Brick,
                ],
            },
            {
                id: '2',
                name: 'Roof',
                layers: [
                    this.layerExtFrt2Roof,
                ],
            },
            {
                id: '3',
                name: 'Shutters',
                layers: [
                    this.layerExtFrt2Shutters,
                ],
            },
            {
                id: '4',
                name: 'Siding',
                layers: [
                    this.layerExtFrt2Siding,
                ],
            },
            {
                id: '5',
                name: 'Stone',
                layers: [
                    this.layerExtFrt2Stone,
                ],
            }
        ]
    };
*/
    /** Data: Exterior View - Front (Option 3): Side Garage */
/*
    layerExtFrt3Brick: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Farmington',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Brick/Layers/L1' + '/Farmington.png',
            },
            {
                name: 'Millbrook',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Brick/Layers/L1' + '/Millbrook.png',
            },
            {
                name: 'St Louis',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Brick/Layers/L1' + '/St Louis.png',
            }
        ]
    };
    layerExtFrt3Roof: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Charcoal',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Roof/Layers/L1' + '/Charcoal.png',
            },
            {
                name: 'Driftwood',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Roof/Layers/L1' + '/Driftwood.png',
            },
            {
                name: 'Weatherwood',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Roof/Layers/L1' + '/Weatherwood.png',
            }
        ]
    };
    layerExtFrt3Shutters: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Brown',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Shutters/Layers/L1' + '/Brown.png',
            },
            {
                name: 'Green',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Shutters/Layers/L1' + '/Green.png',
            },
            {
                name: 'Red',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Shutters/Layers/L1' + '/Red.png',
            }
        ]
    };
    layerExtFrt3Siding: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Cream',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Siding/Layers/L1' + '/Cream.png',
            },
            {
                name: 'Green',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Siding/Layers/L1' + '/Green.png',
            },
            {
                name: 'Tan',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Siding/Layers/L1' + '/Tan.png',
            }
        ]
    };
    layerExtFrt3Stone: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Gray',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Stone/Layers/L1' + '/Gray.png',
            },
            {
                name: 'Natural',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Stone/Layers/L1' + '/Natural.png',
            },
            {
                name: 'Tan',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/SubO_Stone/Layers/L1' + '/Tan.png',
            }
        ]
    };
    optionExteriorFront3: Options = {
        id: '3',
        name: 'Side Garage',
        description: 'Large porch with garage in side',
        pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Exterior/SubV_Front/Options/O_Side Garage/Base/' + 'Side Garage.jpg',
        subOptions: [
            {
                id: '1',
                name: 'Brick',
                layers: [
                    this.layerExtFrt3Brick,
                ],
            },
            {
                id: '2',
                name: 'Roof',
                layers: [
                    this.layerExtFrt3Roof,
                ],
            },
            {
                id: '3',
                name: 'Shutters',
                layers: [
                    this.layerExtFrt3Shutters,
                ],
            },
            {
                id: '4',
                name: 'Siding',
                layers: [
                    this.layerExtFrt3Siding,
                ],
            },
            {
                id: '5',
                name: 'Stone',
                layers: [
                    this.layerExtFrt3Stone,
                ],
            }
        ]
    };
*/
    /** Data: Interior View - Kitchen (Option 1): Island with cabinets */
/*
    layerIntKit1CounterTop1: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'White',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/SubO_Counter Top/Layers/L1' + '/White.png',
            },
            {
                name: 'Black',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/SubO_Counter Top/Layers/L1' + '/Black.png',
            },
            {
                name: 'Brown',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/SubO_Counter Top/Layers/L1' + '/Brown.png',
            }
        ]
    };
    layerIntKit1InslandCabinets: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'White',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/SubO_Island Cabinets/Layers/L1' + '/White.png',
            }
        ]
    };
    layerIntKit1Floor: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Light Brown',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/SubO_Floor/Layers/L1' + '/Gray.png',
            },
            {
                name: 'Medium Brown',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/SubO_Floor/Layers/L1' + '/Medium Brown.png',
            },
            {
                name: 'Dark Brown',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/SubO_Floor/Layers/L1' + '/Dark Brown.png',
            }
        ]
    };
    layerIntKit1Cabinets: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Glass',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/SubO_Floor/Layers/L1' + '/Light Brown.png',
            }
        ]
    };
    optionInteriorKitchen1: Options = {
        id: '1',
        name: 'Island with gabinets',
        description: 'Central island in kitchen with counter top and bottom cabinets',
        pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with gabinets/Base' + '/Island with gabinets.jpg',
        subOptions: [
            {
                id: '1',
                name: 'Counter Top',
                layers: [
                    this.layerIntKit1CounterTop1,
                ],
            },
            {
                id: '2',
                name: 'Island Cabinets',
                layers: [
                    this.layerIntKit1InslandCabinets,
                ],
            },
            {
                id: '3',
                name: 'Floor',
                layers: [
                    this.layerIntKit1Floor,
                ],
            },
            {
                id: '4',
                name: 'Cabinets',
                layers: [
                    this.layerIntKit1Cabinets,
                ],
            }
        ]
    };
*/
    /** Data: Interior View - Kitchen (Option 2): Island with chairs */
/*
    layerIntKit2CounterTop1: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Tan',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/SubO_Counter Top/Layers/L1' + '/Tan.png',
            },
            {
                name: 'Black',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/SubO_Counter Top/Layers/L1' + '/Black.png',
            }
        ]
    };
    layerIntKit2InslandCabinets: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Blue',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/SubO_Island Cabinets/Layers/L1' + '/Blue.png',
            },
            {
                name: 'White',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/SubO_Island Cabinets/Layers/L1' + '/White.png',
            }
        ]
    };
    layerIntKit2Floor: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Light Brown',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/SubO_Floor/Layers/L1' + '/Light Brown.png',
            },
            {
                name: 'Medium Brown',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/SubO_Floor/Layers/L1' + '/Dark Brown.png',
            },
            {
                name: 'Dark Brown',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/SubO_Floor/Layers/L1' + '/Medium Brown.png',
            }
        ]
    };
    layerIntKit2Cabinets: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Glass',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/SubO_Cabinets/Layers/L1' + '/Glass.png',
            }
        ]
    };
    optionInteriorKitchen2: Options = {
        id: '2',
        name: 'Island with chairs',
        description: 'Central island in kitchen with counter top and chairs',
        pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Kitchen/Options/O_Island with chairs/Base' + '/Island with chairs.jpg',
        subOptions: [
            {
                id: '1',
                name: 'Counter Top',
                layers: [
                    this.layerIntKit2CounterTop1,
                ],
            },
            {
                id: '2',
                name: 'Island Bottom',
                layers: [
                    this.layerIntKit2InslandCabinets,
                ],
            },
            {
                id: '3',
                name: 'Cabinets',
                layers: [
                    this.layerIntKit2Cabinets,
                ],
            },
            {
                id: '4',
                name: 'Floor',
                layers: [
                    this.layerIntKit2Floor,
                ],
            }
        ]
    };
*/
    /** Data: Interior View - Living Room (Option 1): Fireplace */
/*
    layerIntLivRom1Wall: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'White',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Living Room/Options/O_Fireplace/SubO_Wall/Layers/L1' + '/White.png',
            }
        ]
    };
    layerIntLivRom1Floor: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Medium',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Living Room/Options/O_Fireplace/SubO_Floor/Layers/L1' + '/Medium.png',
            },
            {
                name: 'Dark',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Living Room/Options/O_Fireplace/SubO_Floor/Layers/L1' + '/Dark.png',
            }
        ]
    };
    optionInteriorLivingRoom1: Options = {
        id: '1',
        name: 'Fireplace',
        description: 'Living Room with fireplace',
        pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Living Room/Options/O_Fireplace/Base' + '/Fireplace.jpg',
        subOptions: [
            {
                id: '1',
                name: 'Floor',
                layers: [
                    this.layerIntLivRom1Floor,
                ],
            },
            {
                id: '2',
                name: 'Wall',
                layers: [
                    this.layerIntLivRom1Wall,
                ],
            }
        ]
    };
*/
    /** Data: Interior View - Living Room (Option 2): Without Fireplace */
/*
    layerIntLivRom2Wall: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'White',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Living Room/Options/O_Without Fireplace/SubO_Wall/Layers/L1' + '/White.png',
            }
        ]
    };
    layerIntLivRom2Floor: Layers = {
        level: 1,
        itemActive: 0,
        items: [
            {
                name: 'Medium',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Living Room/Options/O_Without Fireplace/SubO_Floor/Layers/L1' + '/Medium.png',
            },
            {
                name: 'Dark',
                pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Living Room/Options/O_Without Fireplace/SubO_Floor/Layers/L1' + '/Dark.png',
            }
        ]
    };
    optionInteriorLivingRoom2: Options = {
        id: '2',
        name: 'Without Fireplace',
        description: 'Living Room with fireplace',
        pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Interior/SubV_Living Room/Options/O_Without Fireplace/Base' + '/Without Fireplace.jpg',
        subOptions: [
            {
                id: '1',
                name: 'Floor',
                layers: [
                    this.layerIntLivRom2Floor,
                ],
            },
            {
                id: '2',
                name: 'Wall',
                layers: [
                    this.layerIntLivRom2Wall,
                ],
            }
        ]
    };
*/
    /** Data Floor Plan - Lower Level (Option 1-2-3): Additional Options */
/*
    optionsFloorPlanLowerLevel: Options[] = [
        {
            id: '1',
            name: 'Additional Options',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/Base' + '/Lower Level.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Opt.Rear Morning Room',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Morning Room',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/O_Additional Options/SubO_Opt.Rear Morning Room/Layers/L1' + '/Opt.Rear Morning Room.png',
                                }
                            ]
                        }
                    ],
                },
                {
                    id: '2',
                    name: 'Walk out Condition',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Walk Out',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/O_Additional Options/SubO_Walk out Condition/Layers/L1' + '/Walk out Condition.png',
                                }
                            ]
                        }
                    ],
                },

            ]
        },
        {
            id: '2',
            name: 'Bedrooms',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/Base' + '/Lower Level.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Lower Level Bedroom',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'With Half Bath',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/O_Bedrooms/SubO_Lower Level Bedroom/Layers/L1' + '/Lower Level Bedroom w Half Bath.png',
                                },
                                {
                                    name: 'With Full Bath',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/O_Bedrooms/SubO_Lower Level Bedroom/Layers/L1' + '/Lower Level Bedroom w Full Bath.png',
                                }
                            ]
                        }
                    ],
                }
            ]
        },
        {
            id: '3',
            name: 'Rec Rooms',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/Base' + '/Lower Level.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Family Room',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: '4\' Family Room Extension Exp Above',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/O_Rec Rooms/SubO_Family Room/Layers/L1' + '/4\' Family Room Extension Exp Above.png',
                                },
                                {
                                    name: '6\' Family Room Exp above',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/O_Rec Rooms/SubO_Family Room/Layers/L1' + '/6\' Family Room Exp above.png',
                                }
                            ]
                        }
                    ],
                },
                {
                    id: '1',
                    name: 'Recreation Room',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Opt. Recreation Room',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Lower Level/Options/O_Rec Rooms/SubO_Opt. Recreation Room/Layers/L1' + '/Opt. Recreation Room.png',
                                }
                            ]
                        }
                    ],
                }
            ]
        }
    ];
*/
    /** Data Floor Plan - First Floor (Option 1-2-3-4): Additional Options */
/*
    optionsFirstFloorLevel: Options[] = [
        {
            id: '1',
            name: 'Additional Options',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/Base' + '/First floor.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Opt.Family Foyer',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Family Foyer',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/O_Additional Options/SubO_Family Foyer/Layers/L1' + '/Family Foyer.png',
                                }
                            ]
                        }
                    ],
                },
                {
                    id: '2',
                    name: 'Multi Gen Suite',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Multi Gen Suite',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/O_Additional Options/SubO_Multi Gen Suite/Layers/L1' + '/Multi Gen Suite.png',
                                }
                            ]
                        }
                    ],
                },

            ]
        },
        {
            id: '2',
            name: 'Family Room',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/Base' + '/First floor.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Expanded Family Room',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: '4\' Expanded Family Room',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/O_Family Room/SubO_Expanded Family Room/Layers/L1' + '/4\' Expanded Family Room.png',
                                },
                                {
                                    name: '6\' Expanded Family Room',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/O_Family Room/SubO_Expanded Family Room/Layers/L1' + '/6\' Expanded Family Room.png',
                                }
                            ]
                        }
                    ],
                }
            ]
        },
        {
            id: '3',
            name: 'Garage',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/Base' + '/First floor.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Side Entry Garage',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: '4\' Family Room Extension Exp Above',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/O_Garage/SubO_Side Entry Garage/Layers/L1' + '/Side Entry Garage.png',
                                }
                            ]
                        }
                    ],
                }
            ]
        },
        {
            id: '4',
            name: 'Kitchen Breakfast',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/Base' + '/First floor.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Rear Morning Room',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Rear Morning Room and 4\' Exp. Family Room',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/O_Kitchen Breakfast/SubO_Rear Morning Room/Layers/L1' + '/Rear Morning Room and 4\' Exp. Family Room.png',
                                },
                                {
                                    name: 'Rear Morning Room',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_First Floor/Options/O_Kitchen Breakfast/SubO_Rear Morning Room/Layers/L1' + '/Rear Morning Room.png',
                                }
                            ]
                        }
                    ],
                }
            ]
        }
    ];
*/
    /** Data Floor Plan - Second Floor (Option 1-2-3): Additional Options */
/*
    optionsSecondFloorLevel: Options[] = [
        {
            id: '1',
            name: 'Additional Options',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Second Floor/Options/Base' + '/Second Floor.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Laundry over Foyer',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Laundry over Foyer',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Second Floor/Options/O_Additional Options/SubO_Laundry over Foyer/Layers/L1' + '/Laundry over Foyer.png',
                                }
                            ]
                        }
                    ],
                },
                {
                    id: '2',
                    name: 'Sitting Room and Covered Porch',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Sitting Room and Covered Porch over Optional Rear Morning Room Below',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Second Floor/Options/O_Additional Options/SubO_Sitting Room and Covered Porch/Layers/L1' + '/Sitting Room and Covered Porch over Optional Rear Morning Room Below.png',
                                }
                            ]
                        }
                    ],
                },

            ]
        },
        {
            id: '2',
            name: 'Bathrooms',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Second Floor/Options/Base' + '/Second Floor.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Bedroom 3&4 buddy bath 3&4',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Bedroom #3 4 buddy bath 3 & 4',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Second Floor/Options/O_Bathrooms/SubO_Bedroom 3&4 buddy bath 3&4/Layers/L1' + '/Bedroom-3-4.png',
                                }
                            ]
                        }
                    ],
                },
                {
                    id: '2',
                    name: 'Owner\'s Spa Bath Suite',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Owner\'s Spa Bath Suite',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Second Floor/Options/O_Bathrooms/SubO_Owner\'s Spa Bath Suite/Layers/L1' + '/Owner\'s Spa Bath Suite.png',
                                }
                            ]
                        }
                    ],
                }
            ]
        },
        {
            id: '3',
            name: 'Bedrooms',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Second Floor/Options/Base' + '/Second Floor.svg',
            subOptions: [
                {
                    id: '1',
                    name: 'Bedroom 5',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Bedroom 5',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Floorplan/SubV_Second Floor/Options/O_Bedrooms/SubO_Bedroom 5/Layers/L1' + '/Bedroom 5.png',
                                }
                            ]
                        }
                    ],
                }
            ]
        }
    ];
*/
    /** Data Site Plan - Main Site (Option Lots) */
/*
    optionsSitePlanMainSite: Options[] = [
        {
            id: '1',
            name: 'Lot 17',
            description: '',
            pathBasePicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Site Plan/SubV_Main Site/Options/Base' + '/Base-Site Plan.jpg',
            subOptions: [
                {
                    id: '1',
                    name: 'Lot 17',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: '17',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Site Plan/SubV_Main Site/Options/O_Lot17/SubO_Lot 17/Layers/L1' + '/17.png',
                                }
                            ]
                        },
                        {
                            level: 2,
                            itemActive: -1,
                            items: [
                                {
                                    name: '17',
                                    pathLayerPicture: this.basePath + 'Project_New Lake Houses/Model_A/Views/V_Site Plan/SubV_Main Site/Options/O_Lot17/SubO_Lot 17/Layers/L2' + '/17.svg',
                                }
                            ]
                        }
                    ],
                },
            ]
        },
    ];
*/
    /** Data Site Plan - Main Site (Option Lots) */
/*
    options360ViewKitchen: Options[] = [
        {
            id: '1',
            name: 'Kitchen and Living Room',
            description: 'This view containe a mix places, Kitchen and Living Room',
            pathBasePicture: '',
            subOptions: [
                {
                    id: '1',
                    name: 'Wall and Fireplace',
                    layers: [
                        {
                            level: 1,
                            itemActive: -1,
                            items: [
                                {
                                    name: 'Grey Wall',
                                    pathLayerPicture: 'https://storage.googleapis.com/artistic-vision/360%20View/base.jpg',
                                },
                                {
                                    name: 'Blue Wall',
                                    pathLayerPicture: 'https://storage.googleapis.com/artistic-vision/360%20View/blue%20wall.jpg',
                                },
                                {
                                    name: 'Green Wall',
                                    pathLayerPicture: 'https://storage.googleapis.com/artistic-vision/360%20View/green%20wall.jpg',
                                },
                                {
                                    name: 'Without Fireplace',
                                    pathLayerPicture: 'https://storage.googleapis.com/artistic-vision/360%20View/no%20fireplace.jpg',
                                }
                            ]
                        }
                    ],
                },
            ]
        },
    ];
*/
    /** Model A of the Project [1]: House Lakes */
/*
    modelA: Models = {
        id: 'A',
        name: 'Model A',
        description: '2 bedroom | 1 bathroom | Living Room | Kitchen',
        coverPicture: '',
        views: [

            {
                id: '1',
                name: 'Exterior',
                subView: [
                    {
                        id: '1',
                        name: 'Front',
                        options: [
                            this.optionExteriorFront1,
                            this.optionExteriorFront2,
                            this.optionExteriorFront3
                        ],
                    }
                ],
            },
            {
                id: '2',
                name: 'Interior',
                subView: [
                    {
                        id: '1',
                        name: 'Kitchen',
                        options: [
                            this.optionInteriorKitchen1,
                            this.optionInteriorKitchen2
                        ],
                    },
                    {
                        id: '2',
                        name: 'Living Room',
                        options: [
                            this.optionInteriorLivingRoom1,
                            this.optionInteriorLivingRoom2
                        ],
                    }
                ],
            },
            {
                id: '3',
                name: 'Floor Plan',
                subView: [
                    {
                        id: '1',
                        name: 'Lower Level',
                        options: this.optionsFloorPlanLowerLevel

                    },
                    {
                        id: '2',
                        name: 'First Floor',
                        options: this.optionsFirstFloorLevel
                    },
                    {
                        id: '3',
                        name: 'Second Floor',
                        options: this.optionsSecondFloorLevel
                    }
                ],
            },
            {
                id: '4',
                name: 'Site Plan',
                subView: [
                    {
                        id: '1',
                        name: 'Main Site',
                        options: this.optionsSitePlanMainSite

                    }
                ],
            },
            {
                id: '5',
                name: '360 View',
                subView: [
                    {
                        id: '1',
                        name: 'Interior',
                        options: this.options360ViewKitchen

                    }
                ],
            }
        ],
    };

    projectModels: Models[] = [
        this.modelA,
    ];
    projects: Project[] = [
        {
            id: 1,
            name: 'House Lakes',
            description: 'Houses with 2 Floor close at Lake',
            builderName: 'Seeed Builder Mock',
            address: {
                street: '7907 NW 69th Terrace',
                city: 'Tamarac',
                state: 'Florida',
                zipCode: '33321',
            },
            location: '26.2205575,-80.2451325',
            map: 'https://www.google.com/maps/place/7900+NW+69th+Terrace,+Tamarac,+FL+33321',
            tagLine: '',
            contact: {
                name: 'Rowland Saer',
                title: 'Seller',
                phone: '+1 789 564 4211',
            },
            webSite: 'https://www.housesoflake.us',
            gallery: {
                coverImg: '',
                images: []
            },
            units: {
                quantity: 30,
                status: [],
            },
            modelActive: 0,
            models: this.projectModels,
            //views: this.projectViews,
        }
    ];//end projects

    getAll(): Observable<Project[]> {
        return observableOf(this.projects);
    }

    getCurrentProject(): Observable<Project> {
        return observableOf(this.projects[0]);
    }

    get(id: number): Observable<Project> {
        return observableOf(this.projects.find(x => x.id === id));
    }

    updateCurrent(user: Project): Observable<Project> {
        this.projects[0] = user;
        return observableOf(this.projects[0]);
    }

    update(user: Project): Observable<Project> {
        const i = this.projects.indexOf(this.projects.find(x => x.id === user.id));
        if (i >= 0) {
            this.projects[i] = user;
        }
        return observableOf(user);
    }

    // create(user: Project): Observable<Project> {
    //     user.id = Math.max(...this.projects.map(x => x.id)) + 1;
    //     this.projects.push(user);
    //     return observableOf(user);
    // }

    // delete(id: number): Observable<boolean> {
    //     this.projects = [...this.projects.filter(x => x.id !== id)];
    //     return observableOf();
    // }

*/
}